import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamsGateContext = /*#__PURE__*/createContext(false);
export function TeamsGateProvider({
  isUngatedForTeamsGate,
  children
}) {
  return /*#__PURE__*/_jsx(TeamsGateContext.Provider, {
    value: !!isUngatedForTeamsGate,
    children: children
  });
}
export function useTeamsGate() {
  return useContext(TeamsGateContext);
}